export default __webpack_public_path__ + "static/media/baxterRenalVertical.6bb5b801.png";